import React, { useContext } from "react";
import { motion } from "framer-motion";
import "./Greeting.scss";
import SocialMedia from "../../components/socialMedia/SocialMedia";
import Button from "../../components/button/Button";
import { greeting } from "../../portfolio";
import StyleContext from "../../contexts/StyleContext";

export default function Greeting() {
  const { isDark } = useContext(StyleContext);
  if (!greeting.displayGreeting) return null;

  return (
    <motion.div
      initial={{ opacity: 0, y: 40 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 1 }}
    >
      <div className="greet-main content-rail" id="greeting">
        <div className="greeting-main">
          <div className="greeting-text-div" style={{ textAlign: "justify" }}>
            <h1 className={isDark ? "dark-mode greeting-text" : "greeting-text"}>
              {greeting.title}
            </h1>

            <p className={isDark ? "dark-mode greeting-text-p" : "greeting-text-p subTitle"}>
              {greeting.subTitle}
            </p>

            <div id="resume" className="empty-div" />
            <SocialMedia />

            {greeting.resumeLink && (
              <div className="button-greeting-div">
                <a
                  href={require("./resume_v1.2.pdf")}
                  download="Resume.pdf"
                  className="download-link-button"
                >
                  <Button text="Resume" />
                </a>
              </div>
            )}
          </div>

          <div className="greeting-image-div">
            <img
              className="greeting-image"
              alt="Hakan profile"
              src={require("../../assets/images/PixelArt_PhotoHakan.png")}
            />
          </div>
        </div>
      </div>
    </motion.div>
  );
}
